<template>
  <v-container class="grey lighten-5">
    <v-row>
      <v-img
        height="50%"
        src="https://cdn.vuetifyjs.com/images/cards/server-room.jpg"
      >
        <v-row align="end" class="fill-height">
          <v-col align-self="start" class="pa-0" cols="12">
            <v-avatar class="profile" color="grey" size="164" tile>
              <v-img
                src="https://cdn.vuetifyjs.com/images/profiles/marcus.jpg"
              ></v-img>
            </v-avatar>
          </v-col>
          <v-col class="py-0">
            <v-list-item color="rgba(0, 0, 0, .4)" dark>
              <v-list-item-content>
                <v-list-item-title class="title"
                  >Marcus Obrien</v-list-item-title
                >
                <v-list-item-subtitle>Network Engineer</v-list-item-subtitle>
                <p>
                  Morbi mattis ullamcorper velit. Donec orci lectus, aliquam ut,
                  faucibus non, euismod id, nulla. Fusce convallis metus id
                  felis luctus adipiscing. Aenean massa. Vestibulum purus quam,
                  scelerisque ut, mollis sed, nonummy id, metus. Nulla consequat
                  massa quis enim. Praesent venenatis metus at tortor pulvinar
                  varius. Donec venenatis vulputate lorem. Phasellus accumsan
                  cursus velit. Pellentesque ut neque.
                </p>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-img>
    </v-row>
    <v-row>
      <v-btn icon>
        <v-icon title="LinkedIn">mdi-linkedin</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon title="Facebook">mdi-facebook</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon title="Twitter">mdi-twitter</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon title="Permalink">mdi-link</v-icon>
      </v-btn>
    </v-row>
    <template>
      <v-card>
        <v-tabs
          v-model="tab"
          background-color="deep-purple accent-4"
          centered
          dark
          icons-and-text
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab href="#tab-1">
            Posters
            <v-icon>mdi-phone</v-icon>
          </v-tab>

          <v-tab href="#tab-2">
            History
            <v-icon>mdi-heart</v-icon>
          </v-tab>

          <v-tab href="#tab-3">
            Followers
            <v-icon>mdi-account-box</v-icon>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item v-for="i in 3" :key="i" :value="'tab-' + i">
            <v-card flat>
              <v-card-text>{{ text }}</v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </template>
  </v-container>
</template>

<script>
export default {
  name: "Profile",
  components: {},
  data() {
    return {
      tab: null,
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    };
  }
};
</script>

<style></style>
